module.exports = __webpack_public_path__ + "images/02fa4e8b93fc6e1e7c6b0f375b45dd9e-IMG_6382.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slides/kitchen/IMG_6382.jpg
// module id = ./src/assets/images/slides/kitchen/IMG_6382.jpg
// module chunks = 0